import {
  PostSupplierHearingMailReqParams
} from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

/**
 * POST /api/supplier/hearing/mailのゲートウェイクラス
 */
export class PostSupplierHearingMailGateway {
  /** 業者ヒアリング状況確認-メール送信 */
  static postSupplierHearingMail = async (params: PostSupplierHearingMailReqParams) => {
    return await yamadumiApi.post('/api/supplier/hearing/mail', params)
  }
}
